export const CSRF_TOKEN_KEY = 'csrf_token';
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const SECRET_TOKEN = 'secretToken';
export const USER_TOKEN = 'user';
